import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollRestoration() {
  const location = useLocation();
  const prevPathname = useRef(location.pathname);

  useEffect(() => {
    if (location.hash) {
      const timeoutId = setTimeout(() => {
        const elementId = location.hash.slice(1);
        const element = document.getElementById(elementId);
        if (element) {
          const headerOffset = 100;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      }, 100);

      return () => clearTimeout(timeoutId);
    }

    if (prevPathname.current !== location.pathname) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }

    prevPathname.current = location.pathname;
  }, [location.pathname, location.hash, location.key]);

  return null;
}
